import { ArrowBackIos } from '@mui/icons-material';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { Header } from '../../../components/header/header';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import Strings from '../../../i18n';
import { ButtonIconStyled } from '../../devices/devicesStyles';
import { SportTroubleShootingTemplate } from '../../../templates/applications/sports/sportTroubleShooting/sportTroubleShootingTemplate';

export const SportTroubleshootingView = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  return (
    <div>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled
                size="small"
                onClick={() =>
                  navigate(`/locations/${locationId}/applications/game_day`)
                }
              >
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>
                {Strings.sports.sportTroubleshooting}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right" />
          </div>
        </StyledHeaderContainer>
      </Header>
      <SportTroubleShootingTemplate />
    </div>
  );
};
